import { apiClient } from '@/api/client'
import { ORGANIZATION_DASHBOARD } from '@/api/endpoints'
import type { ApiResponseWrapper } from '@/types/api.types'
import type { OrganizationDashboard } from '@/types/dashboard.types'

/** @param date Optional past day (YYYY-MM-DD); omitted means live. */
export async function getOrganizationDashboard(
  date?: string | null
): Promise<OrganizationDashboard> {
  const { data } = await apiClient.get<ApiResponseWrapper<OrganizationDashboard>>(
    ORGANIZATION_DASHBOARD,
    { params: date ? { date } : undefined }
  )
  if (data?.data && typeof data.data === 'object') {
    return data.data
  }
  throw new Error('Failed to load organization dashboard')
}
